const AUDIENCE_FLAGS = [
    'include_league_players',
    'include_season_players',
    'include_team_players',
    'include_selected_players',
    'include_subscribers',
    'include_previous_players',
];

export function campaignHasAudience(audience) {
    return AUDIENCE_FLAGS.some((key) => Boolean(audience?.[key]));
}

function isHtmlDump(value) {
    const text = String(value).trim();
    return text.startsWith('<!') || text.startsWith('<html') || text.includes('<title>ValidationError');
}

function flattenMessages(value) {
    if (value == null) return [];
    if (Array.isArray(value)) return value.flatMap(flattenMessages);
    if (typeof value === 'object') {
        return Object.entries(value).flatMap(([key, val]) => {
            const msgs = flattenMessages(val);
            if (key === 'detail' || key === '__all__' || key === 'non_field_errors') {
                return msgs;
            }
            return msgs.map((msg) => `${key}: ${msg}`);
        });
    }
    return [String(value)];
}

export function formatCampaignSaveError(err, fallback = 'Save failed.') {
    const data = err?.response?.data;
    if (data == null) return fallback;
    if (typeof data === 'string') {
        return isHtmlDump(data) ? fallback : data;
    }
    const messages = flattenMessages(data).filter((msg) => !isHtmlDump(msg));
    return messages.join(' ') || fallback;
}

export const AUDIENCE_REQUIRED_MESSAGE = 'Select at least one campaign audience before sending.';
export const SCHEDULE_REQUIRED_MESSAGE = 'Choose a send time, or use Send now.';
export const SCHEDULE_FUTURE_MESSAGE = 'Send time must be in the future.';

function pad2(n) {
    return String(n).padStart(2, '0');
}

export function toDatetimeLocalValue(date) {
    const d = date instanceof Date ? date : new Date(date);
    if (Number.isNaN(d.getTime())) return '';
    return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}T${pad2(d.getHours())}:${pad2(d.getMinutes())}`;
}

export function scheduleInOneMinute() {
    return toDatetimeLocalValue(new Date(Date.now() + 60_000));
}

export function isScheduleInFuture(value) {
    if (!value) return false;
    const t = new Date(value).getTime();
    return Number.isFinite(t) && t > Date.now();
}

export function audienceSummaryLabels(audience) {
    return [
        audience.include_league_players && 'League players',
        audience.include_season_players && `${(audience.season_ids || []).length || 'All'} season(s)`,
        audience.include_team_players && `${(audience.team_ids || []).length || 'All'} team(s)`,
        audience.include_selected_players && `${(audience.selected_player_ids || []).length} selected players`,
        audience.include_subscribers && 'Subscribers',
        audience.include_previous_players && 'Previous players',
    ].filter(Boolean).join(', ') || 'None selected';
}

export const EMPTY_AUDIENCE = {
    include_league_players: false,
    include_season_players: false,
    include_team_players: false,
    include_selected_players: false,
    include_subscribers: false,
    include_previous_players: false,
    season_ids: [],
    team_ids: [],
    selected_player_ids: [],
    selected_player_names: [],
    selected_email_list_ids: [],
    manually_excluded_emails: [],
};
